import { render, staticRenderFns } from "./PwpQuestions.vue?vue&type=template&id=c4ec92c6&scoped=true&"
import script from "./PwpQuestions.vue?vue&type=script&lang=js&"
export * from "./PwpQuestions.vue?vue&type=script&lang=js&"
import style0 from "./PwpQuestions.vue?vue&type=style&index=0&id=c4ec92c6&lang=scss&scoped=true&"
import style1 from "./PwpQuestions.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./PwpQuestions.vue?vue&type=style&index=2&id=c4ec92c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ec92c6",
  null
  
)

export default component.exports